import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import QedaraLogo from "@/components/QedaraLogo";

export default function ResetPassword({ token, onDone }) {
  const { reset } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Parola trebuie să aibă cel puțin 6 caractere");
    if (password !== confirm) return toast.error("Parolele nu se potrivesc");
    setLoading(true);
    try {
      await reset(token, password);
      toast.success("Parola a fost schimbată");
      onDone();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Resetarea nu a reușit — poate a expirat linkul");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg text-fg p-6">
      <div className="w-full max-w-sm">
        <div className="mb-8"><QedaraLogo variant="full" markSize={40} /></div>
        <p className="label-tiny mb-3">// RESETARE PAROLĂ</p>
        <h1 className="text-3xl font-bold tracking-tighter mb-2">Alege o parolă nouă.</h1>
        <p className="text-fg/60 mb-8 text-sm">Scrie-o de două ori, ca să fim siguri.</p>

        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div>
            <label className="label-tiny block mb-2">Parolă nouă</label>
            <input
              data-testid="reset-password-input"
              type="password" required minLength={6}
              className="input-flat"
              value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </div>
          <div>
            <label className="label-tiny block mb-2">Confirmă parola</label>
            <input
              data-testid="reset-confirm-input"
              type="password" required minLength={6}
              className="input-flat"
              value={confirm} onChange={(e) => setConfirm(e.target.value)}
              placeholder="••••••••"
            />
          </div>
          <button
            data-testid="reset-submit-button"
            type="submit" disabled={loading}
            className="btn-primary w-full flex items-center justify-center gap-2 mt-6"
          >
            {loading ? "..." : "Schimbă parola"}
            <ArrowRight className="w-4 h-4" />
          </button>
        </form>
      </div>
    </div>
  );
}
